import {Box, MenuItem, Select, SelectProps} from '@mui/material';
import {FC, useState} from 'react';
import {useAppDispatch, useAppSelector} from 'src/app/hooks';
import {changeLang} from 'src/stores/common/commonSlice';
import {langSelectSx, langWrapperSx} from './LangSelect.sx';
import {LanguageShortEnum, NormalizeLanguageEnum} from '../../../enums';

/**
 * Ukrainian is offered only inside the Ukrainian business.
 *
 * Hardcoded against the business name on purpose: there is exactly one such business, and the match is
 * the whole rule. If a second market ever appears this becomes a field on the business rather than a
 * longer pattern here.
 */
const UKRAINIAN_BUSINESS = /ukraine/i;

const data = [
    {
        value: LanguageShortEnum.EN,
        option: NormalizeLanguageEnum.ENGLISH,
    },
    {
        value: LanguageShortEnum.FR,
        option: NormalizeLanguageEnum.FRENCH,
    },
    {
        value: LanguageShortEnum.DE,
        option: NormalizeLanguageEnum.DEUTSCH,
    },
    {
        value: LanguageShortEnum.UK,
        option: NormalizeLanguageEnum.UKRAINIAN,
    },
];

export const LangSelect: FC<{ short?: boolean; white?: boolean }> = ({
                                                                         short = false,
                                                                         white = false,
                                                                     }) => {
    const {lang, authInfo} = useAppSelector((state) => state.common);
    const [language, setLanguage] = useState<string>(lang);
    // Signed out - on the login, sign-up and set-password screens - there is no business to read, so
    // the extra language simply is not on offer there. It stays listed while it is the language being
    // shown, because a Select whose value is missing from its options renders blank.
    const businessName = authInfo?.business?.name ?? '';
    const options = UKRAINIAN_BUSINESS.test(businessName) || language === LanguageShortEnum.UK
        ? data
        : data.filter((item) => item.value !== LanguageShortEnum.UK);
    const dispatch = useAppDispatch();
    const handleChangeLang: SelectProps<string>['onChange'] = (e) => {
        setLanguage(e.target.value);
        dispatch(changeLang(e.target.value));
    };

    return (
        <Box sx={langWrapperSx}>
            <Select
                labelId="lang-select"
                id="lang-select"
                value={language}
                label="Language"
                onChange={handleChangeLang}
                sx={langSelectSx(white)}
                variant="standard"
                disableUnderline
            >
                {options.map((item, index) => (
                    <MenuItem
                        value={item.value}
                        key={index}
                    >
                        {!short ? item.option : item.option.slice(0, 2)}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
};
